// @flow

import styled, { css } from 'styled-components';

export default styled.div.attrs({
  rowid: (props : any) => props.rowid,
})`
  width: 100%;
  z-index: 2;
  opacity: 1;
  float: right;
  .content {
    white-space: nowrap;
    font-size: 0;
    overflow: hidden;
    float: right;
    clear: both;
    width: 100%;
    margin-bottom: ${(props : any) => (props.tagList && '2rem')};
    position: relative;
    &:hover {
      > .arrow {
        opacity: 1;
        &.left {
          left: 0;
        }
        &.right {
          right: 0;
        }
      }
    }
    .horizontal-list {
      white-space: nowrap;
      h1 {
        font-size: 2rem;
        padding: 0;
        line-height: 3rem;
        color: #fff;
      }
      &.selectableRow {
        transition: all ease .15s;
      }
    }
    > .arrow {
      border: none;
      outline: none;
      position: absolute;
      top: 0;
      width: 7rem;
      height: 100%;
      text-align: center;
      opacity: 0;
      transition: all ease .3s;
      cursor: pointer;
      &:hover {
        background-color: rgba(0,0,0,.7) !important;
        > i {
          transform: scale(1.3);
        }
      }
      &.left {
        left: -6rem;
        background: linear-gradient(85deg,rgba(0,0,0,.65),transparent);
      }
      &.right {
        right: -6rem;
        background: linear-gradient(-85deg,rgba(0,0,0,.65),transparent);
      }
      > i {
        transition: all ease .3s;
        font-size: 6rem;
        position: absolute;
        top: 0;
        bottom: 0;
        margin: auto;
        height: 7.3rem;
        left: 0;
        right: 0;
        color: #fff;
      }
    }
  }
  .titleWrapper {
    position: relative;
    ${(props : any) => (props.showSeasonButtons && css`
      height: 3.3rem;
      margin: 1rem 0 2rem;
      float: right;
      width: 100%;
      clear: both;
    `)}    
    .listTitle {
      float: right;
      color: #fff;
      font-size: 2rem;
      position: relative;
      float: right;
      margin: .4rem 0 ${(props : any) => (props.tagList && '0')};
      ${(props : any) => (!props.showSeasonButtons && css`
        margin: 1.6rem 0;
      `)}
    }
    > i {
      float: right;
      font-size: 2.4rem;
      color: #fff;
      margin-top: 1.7rem;
      margin-left: 1rem;
    }
    .seasonsButtonsWrapper {
      position: absolute;
      left: 0;
      top: -.5rem;
      > button {
        margin: 0 .5rem;
        float: right;
        border-radius: 2rem;
        color: #fff;
        line-height: 0;
        cursor: pointer;
        overflow: hidden;
        background: rgba(255,255,255,.4);
        border: .4rem solid transparent;
        font-size: 1.9rem;
        outline: none;
        padding: .7rem 1.2rem;
        position: relative;
        display: table;
        &.prevSeasonButton {
          padding: 1.7rem 4.5rem 1.7rem 2.2rem;
          > i {
            position: absolute;
            right: 1.7rem;
            top: .1rem;
            bottom: 0;
            display: table;
            margin: auto;
          }
        }
        &.nextSeasonButton {
          padding: 1.7rem 2.2rem 1.7rem 4.5rem;
          > i {
            position: absolute;
            left: 1.7rem;
            top: .1rem;
            bottom: 0;
            display: table;
            margin: auto;
          }
        }
        &.activeItem {
          background: #fff;
          border: .4rem solid #ea1d5d;
          color: #020100;
        }
        &:hover {
          background: #fff;
          color: #020100;
        }
      }
    }
  }
`;
